// Sincronizado com OrigemReservaEnum do backend ATS.Hub.API.OrquestradorSuprimentos
export enum OrigemReservaEnum {
  PedidoVenda = 1,
  OrdemProducao = 2,
  Transferencia = 3,
  SeparacaoWMS = 4,
  AvariaDanificado = 6,
  QuarentenaQualidade = 7,
  LoteVencido = 8,
  ReservaTecnica = 9,
  BloqueioJudicial = 10,
  ReservaManual = 11,
  Orcamento = 12,
}
